module.exports = __webpack_public_path__ + "static/img/group-dark.b632498a.png";